/**
 * Typed API client for the auth feature.
 *
 * Errors from both endpoints surface as ``ApiError`` so callers can
 * branch on ``err.status === 401`` uniformly across the app.
 */

import { apiFetch } from "@/lib/api/client"

import type { CurrentUser } from "./types"

/**
 * The top-level navigation URL the "Sign in with Google" button
 * targets. Centralised here so the signin page and its tests agree.
 */
export const GOOGLE_START_URL = "/api/auth/google/start/"

const ME_URL = "/api/auth/me/"
const LOGOUT_URL = "/api/auth/logout/"

export function fetchCurrentUser(init?: RequestInit): Promise<CurrentUser> {
  return apiFetch<CurrentUser>(ME_URL, init)
}

/**
 * Terminate the Django session. ``X-CSRFToken`` is attached by
 * ``apiFetch`` from the ``csrftoken`` cookie. Returns on 204.
 *
 * Bubbles up an ``ApiError`` on any non-2xx — including 401, which
 * the caller should treat as "already signed out" and proceed to the
 * signin route.
 */
export function signOut(init?: RequestInit): Promise<void> {
  return apiFetch<void>(LOGOUT_URL, { ...init, method: "POST" })
}
